import React, { useState, Fragment } from 'react';

// COMPONENTS
import Icon from '../Icon';
import Step from './Step';
import StepMobileClosed from './StepMobileClosed';

// ENUMS
import { Icons } from '../../enums/icons';

// INTE
import { ISteps, IStep } from '../../interfaces/Steps.interface';

// STYLES
import {
  ButtonArrowWrapper,
  LineContainer,
  LineHeight,
  StepContainer,
  StepContainerOpened,
  StepHeaderContainer,
  Title
} from './styles';

const Steps: React.FC<ISteps> = ({ isMobile, steps, title }: ISteps) => {
  const [isOpened, setIsOpened] = useState(false);
  if (isMobile) {
    return (
      <StepContainer isOpened={isOpened}>
        <StepContainerOpened isOpened={isOpened}>
          {isOpened ? (
            <LineContainer>
              <StepHeaderContainer>
                <Title>{title}</Title>
                <LineHeight />
                <ButtonArrowWrapper isOpened={isOpened} onClick={() => setIsOpened(!isOpened)}>
                  <Icon type={Icons.ARROW_UP} />
                </ButtonArrowWrapper>
              </StepHeaderContainer>
              {steps.map((step: IStep, idx: number) => {
                return <Fragment key={idx}>{step.visible && <Step {...step} />}</Fragment>;
              })}
            </LineContainer>
          ) : (
            <>
              {steps.map((step: IStep, idx: number) => {
                return <Fragment key={idx}>{step.visible && <StepMobileClosed step={step} />}</Fragment>;
              })}
              <ButtonArrowWrapper isOpened={isOpened} onClick={() => setIsOpened(!isOpened)}>
                <Icon type={Icons.ARROW_DOWN} />
              </ButtonArrowWrapper>
            </>
          )}
        </StepContainerOpened>
      </StepContainer>
    );
  }

  return (
    <StepContainer>
      <LineContainer>
        <Title>{title}</Title>
        <LineHeight />
        {steps.map((step: IStep, idx: number) => (
          <Fragment key={idx}>{step.visible && <Step {...step} />}</Fragment>
        ))}
      </LineContainer>
    </StepContainer>
  );
};

export default Steps;
